// src/providers/Auth/AllAuthProviders.js
import React from 'react';
import { KickProvider } from './KickProvider';

export const AllAuthProviders = ({ children }) => {
  return (
    <KickProvider>
      {children}
    </KickProvider>
  );
};
